//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  cloneDeep,
  dig,
} from '@/utils/lodash'
import { set } from '@/utils/util'

export default {
  components: {},

  props: {
    flex: {
      type: Boolean,
      default: false,
    },

    value: {
      type: [
        Array,
        String,
        Number,
      ],
      default: '',
    },

    all: {
      type: Boolean,
      default: true,
    },

    list: {
      type: Array,
      default: () => ([]),
    },

    isCanCancel: {
      type: Boolean,
      default: false,
    },

    apiMethod: { type: Function },

    params: {
      type: Object,
      default: () => ({}),
    },

    dataHook: { type: Function },

    valueName: {
      type: String,
      default: 'key',
    },

    dataPath: {
      type: String,
      default: 'data',
    },

    labelName: {
      type: String,
      default: 'value',
    },
  },

  data () {
    return {
      selectedButton: '',
      innerList: [],
    }
  },

  computed: {
    selectAllFlag () {
      return !this.value
    },
  },

  watch: {
    value: {
      handler (val) {
        if (this.innerList?.length) {
          this.innerList.forEach((el) => {
            set(el, 'active', val === el.wid)
          })
        }

        this.selectedButton = (cloneDeep(val) || '')
      },
      deep: true,
      immediate: true,
    },

    list: {
      handler (val) {
        if (val && !this.apiMethod) {
          this.innerList = cloneDeep(this.list).map((el) => {
            return {
              name: el[this.labelName],
              wid: el[this.valueName],
              active: el[this.valueName] === this.value,
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async created () {
    if (this.apiMethod) {
      const data = await this.apiMethod(this.params)
      const result = dig(data, this.dataPath) || []
      this.innerList = (this.dataHook ? this.dataHook(result) : result).map((el) => {
        return {
          name: el[this.labelName],
          wid: el[this.valueName],
        }
      })
    }
  },

  methods: {
    filterActiveFlag (button) {
      return this.selectedButton === button.wid
    },

    selectAll () {
      this.selectedButton = ''

      this.$emit('on-click', this.selectedButton)
      this.$emit('input', this.selectedButton)
    },

    selectButton (button) {
      if (this.isCanCancel && this.selectedButton === button.wid) {
        this.selectedButton = ''
      } else {
        this.selectedButton = button.wid
      }

      this.$emit('on-click', this.selectedButton, button)
      this.$emit('input', this.selectedButton)
    },
  },
}
